import type { IOffer } from 'shared/offer';

export function isFlat(offer: IOffer): boolean {
  return offer.offerType === 'flat';
}
